// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-69f54002]{padding:30px 25px}main p[data-v-69f54002]{margin:15px 0}main a[data-v-69f54002]{color:#000}main h3[data-v-69f54002]{margin:20px 0 10px}main h2[data-v-69f54002]{margin:15px 0}main li[data-v-69f54002],main p[data-v-69f54002]{line-height:150%}", ""]);
// Exports
module.exports = exports;
